import medicamentosData from './medicamentos.json';

export const getMedicamentosPorCategoria = () => medicamentosData.medicamentos;

export const buscarMedicamento = (nomeMedicamento) => {
  const nome = nomeMedicamento.toLowerCase().trim();

  for (const categoria of medicamentosData.medicamentos) {
    for (const item of categoria.items) {
      // Verifica nome principal
      if (item.nome.toLowerCase() === nome) {
        return { ...item, categoria: categoria.categoria };
      }

      // Verifica nomes comerciais
      if (item.nomes_comerciais?.some((comercial) => comercial.toLowerCase() === nome)) {
        return { ...item, categoria: categoria.categoria };
      }
    }
  }

  // Retorna padrão se não encontrar
  return {
    nome: nomeMedicamento,
    nomes_comerciais: [],
    orientacao: 'Tomar 1 comprimido Via Oral cedo.',
    categoria: 'Outros Medicamentos',
  };
};

export const adicionarMedicamentoATexto = (medicamento, numeroReceita = 1) =>
  `${numeroReceita} - ${medicamento.nome}\n      ${medicamento.orientacao}\n`;

export const formatarMedicamentoParaReceita = (medicamento, numeroReceita) => {
  const linhas = [`${numeroReceita} - ${medicamento.nome}`, `      ${medicamento.orientacao}`, ''];
  return linhas.join('\n');
};
